import React, { useState, useContext } from 'react';
import { AudioContext } from '../contexts/AudioContext';
import db from '../db';

function SearchBar({ closeMenu, setSelectedBook }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const { setCurrentChapter, updateSession, setIsPlaying } = useContext(AudioContext);

  const getAudioUrl = (bookId, bookName, chapter) => {
    const paddedBookId = bookId.toString().padStart(2, '0');
    const paddedChapter = chapter.toString().padStart(3, '0');
    const unpaddedChapter = chapter.toString();
    return `/static/audio/esv/${paddedBookId}${paddedChapter}_${bookName} ${unpaddedChapter}.mp3`;
  };

  const handleSearch = async (e) => {
    const value = e.target.value.trim();
    setQuery(e.target.value);
    
    if (value.length < 2) {
      setResults([]);
      return;
    }

    const books = await db.books.toArray();
    // Try to extract chapter number from the end of the search string
    const match = value.match(/^(.+?)(?:\s*(\d+))?$/);
    const bookTerm = match[1].toLowerCase();
    const chapterTerm = match[2];

    const filtered = books
      .map((book) => {
        const bookMatches = 
          book.name.toLowerCase().includes(bookTerm) || 
          (book.abbreviation && book.abbreviation.toLowerCase().includes(bookTerm));

        if (chapterTerm) {
          // If there's a chapter number in the search, only return matching chapters
          if (bookMatches) {
            const chapters = Array.from({ length: book.chapters }, (_, i) => i + 1)
              .filter(ch => ch.toString() === chapterTerm)
              .map(ch => ({
                type: 'chapter',
                data: { bookId: book.id, book: book.name, chapter: ch },
              }));
            return chapters.length ? chapters : null;
          }
        } else if (bookMatches) {
          // If only book name is searched, return the book
          return { type: 'book', data: book };
        }
        return null;
      })
      .flat()
      .filter(Boolean);
    setResults(filtered);
  };

  const handleResultClick = (result) => {
    if (result.type === 'chapter') {
      const chapterData = {
        ...result.data,
        url: getAudioUrl(result.data.bookId, result.data.book, result.data.chapter),
      };
      setCurrentChapter(chapterData);
      setIsPlaying(true);
      updateSession(chapterData);
      closeMenu();
    } else if (result.type === 'book') {
      setSelectedBook(result.data);
    }
    setQuery('');
    setResults([]);
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        value={query}
        onChange={handleSearch}
        placeholder="Search books or chapters..."
      />
      {results.length > 0 && (
        <ul className="search-results">
          {results.map((result, index) => (
            <li key={index} onClick={() => handleResultClick(result)}>
              {result.type === 'book' ? result.data.name : `${result.data.book} ${result.data.chapter}`}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SearchBar;